export const LOADDOMAINS_START = 'react/domains/LOADDOMAINS_START';
export const LOADDOMAINS_COMPLETE = 'react/domains/LOADDOMAINS_COMPLETE';
export const LOADDOMAINS_ERROR = 'react/domains/LOADDOMAINS_ERROR';
export const CHANGE_DOMAINS = 'react/domains/CHANGE_DOMAINS';
export const ADD_DOMAINS = 'react/domains/ADD_DOMAINS';
export const DOMAIN_DESTROY = 'react/domains/DOMAIN_DESTROY';
export const CREATE_DOMAIN = 'react/domains/CREATE_DOMAIN';

const initialState = {
  list: [],
  created: [],
  value: '',
  loading: false
};

export default function (state = initialState, action = {}) {
  switch (action.type) {
    case LOADDOMAINS_COMPLETE: {
      const created = [...state.created];
      if (!action.result) {
        return {
          ...state,
          list: [...created],
          loading: false
        };
      }
      return {
        ...state,
        list: [...action.result.domains, ...created],
        loading: false
      };
    }
    case LOADDOMAINS_START:
      return {
        ...state,
        loading: true
      };
    case LOADDOMAINS_ERROR:
      return {
        ...state,
        loading: false
      };
    case CHANGE_DOMAINS:
      return {
        ...state,
        value: action.data
      };
    case ADD_DOMAINS: {
      const created = state.created.filter(x => x.cityId === action.cityId);
      try {
        return {
          ...state,
          list: [...action.data, ...created] || []
        };
      } catch (err) {
        return {
          ...state,
          list: [...created],
        };
      }
    }
    case CREATE_DOMAIN:
      return {
        ...state,
        list: [...state.list, action.data],
        created: [...state.created, action.data],
        value: action.data
      };
    case DOMAIN_DESTROY:
      return {
        ...state,
        list: [],
        value: '',
        loading: false
      };
    default:
      return state;
  }
}

export function loadDomains(data) {
  return {
    types: [LOADDOMAINS_START, LOADDOMAINS_COMPLETE, LOADDOMAINS_ERROR],
    promise: (client) => client.get('/api/address/localities/' + data)
  };
}

export function createDomain(data) {
  return {
    type: CREATE_DOMAIN,
    data
  };
}

export function changeDomains(data) {
  return {
    type: CHANGE_DOMAINS,
    data
  };
}

export function addDomains(data, cityId) {
  console.log('>>>>', data);
  console.log('>>>>', cityId);
  return {
    type: ADD_DOMAINS,
    data,
    cityId
  };
}

export function destroyDomains() {
  return { type: DOMAIN_DESTROY };
}



// WEBPACK FOOTER //
// ./Scripts/redux/modules/addressForm/domains.js